import {IActJson} from '../../diagram-data/diagram-json-handler.service';
import {ShapeCommand} from '../commands.template';
import * as _ from 'lodash';

declare const mxUtils: any;

export class ActivityDeleteCommand extends ShapeCommand {
  protected services: any;
  private flowlines: any = [];
  private orderIndex: number;

  constructor(data: IActJson) {
    super(data);
  }

  public execute() {
    super.execute();
    const graph = this.services.editorRegistrySvc.getGraph();
    const allActivities = this.services.graphHelperSvc.allActivities() || [];

    this.orderIndex = _.findIndex(
      allActivities,
      (cell: any) => Number(cell.id) === Number(this.object.mxKey)
    );
    const activityCell = allActivities[this.orderIndex];

    if (activityCell.edges) {
      activityCell.edges.forEach(flowline => {
        if (activityCell.edges.length > 0 && activityCell.edges.length !== this.flowlines.length) {
          this.flowlines.push(_.cloneDeep(flowline.getJson()));
        }

        flowline.skipUndo = true;
      });
    }

    this.services.angularCompSvc.destroyComponent(activityCell);
    graph.removeCells([activityCell], false);

    if (this.object.drilldowns && this.object.drilldowns.length > 0) {
      return this.executeJson(this.object, true);
    }

    return this.executeJson(this.object);
  }

  private executeJson(data, withRefresh?) {
    return this.services.diagramUpdateSvc.update(
      {
        deleteActivity: {
          mxKey: Number(data.mxKey)
        }
      },
      false,
      false,
      withRefresh
    );
  }

  public reverse() {
    super.reverse();

    const graph = this.services.editorRegistrySvc.getGraph();

    const activityVertex = this.services.shapeSpawnerSvc.createActivity(this.object);

    graph.addCell(activityVertex, this.services.graphHelperSvc.activityParent(), this.orderIndex);
    this.services.angularCompSvc.setCache(activityVertex.id, activityVertex.comp);
    this.reverseJson(this.object, this.orderIndex);

    if (this.flowlines && this.flowlines.length > 0) {
      this.flowlines.forEach(flowlineJson => {
        const flowlineCell = this.services.editorRegistrySvc
          .getGraph()
          .model.getCell(flowlineJson.mxKey);

        this.services.shapeSpawnerSvc.updateFlowline(flowlineJson, flowlineCell);
        flowlineCell.skipUndo = true;
      });
    }
  }

  private reverseJson(data, orderIndex) {
    if (!data.resources) {
      data.resources = [];
    }

    if (!data.attachments) {
      data.attachments = [];
    }

    const attachments = data.attachments.reduce((acc, curr) => {
      if (!curr || curr.type === 'image' || curr.type === 'datatable' || curr.type === 'text') {
        return acc;
      }

      acc.push({
        id: curr.id,
        itemMxKey: data.mxKey,
        mxKey: curr.mxKey,
        urlEntry: curr.urlEntry,
        type: curr.type,
        title: curr.title,
        value: curr.value,
        groups: curr.groups,
        dataStructureDefinition: curr.dataStructureDefinition,
        savedOnS3: curr.savedOnS3,
        needToRestore: curr.type === 'text' && curr.savedOnS3,
        noteProItems: curr.noteProItems
      });

      return acc;
    }, []);

    if (!data.refModelAttachments) {
      data.refModelAttachments = [];
    }

    const refModelAttachments = data.refModelAttachments.map(attachment => {
      if (attachment) {
        return {
          id: attachment.id,
          itemMxKey: data.mxKey,
          mxKey: attachment.mxKey,
          type: attachment.type,
          title: attachment.title,
          groups: attachment.groups,
          refModel: attachment.refModel,
          refModelNode: attachment.refModelNode,
          description: attachment.description,
          refModelName: attachment.refModelName,
          nodePath: attachment.nodePath,
          externalUrl: attachment.externalUrl
        };
      }
    });

    if (!data.requirementAttachments) {
      data.requirementAttachments = [];
    }

    const requirementAttachments = data.requirementAttachments.map(attachment => {
      if (attachment) {
        return {
          id: attachment.id,
          itemMxKey: data.mxKey,
          mxKey: attachment.mxKey,
          type: attachment.type,
          title: attachment.title,
          groups: attachment.groups,
          requirement: attachment.requirement.id || attachment.requirement,
          description: attachment.description,
          reqId: attachment.reqId,
          reqReason: attachment.reqReason,
          reqDetails: attachment.reqDetails
        };
      }
    });

    if (!data.storyAttachments) {
      data.storyAttachments = [];
    }

    const storyAttachments = data.storyAttachments.map(attachment => {
      if (attachment) {
        return {
          id: attachment.id,
          itemMxKey: data.mxKey,
          mxKey: attachment.mxKey,
          type: attachment.type,
          title: attachment.title,
          groups: attachment.groups,
          description: attachment.description,

          story: attachment.story.id || attachment.story,
          storyId: attachment.storyId
        };
      }
    });

    if (!data.orgModelAttachments) {
      data.orgModelAttachments = [];
    }

    const orgModelAttachments = data.orgModelAttachments.map(attachment => {
      if (attachment) {
        return {
          id: attachment.id,
          itemMxKey: data.mxKey,
          mxKey: attachment.mxKey,
          type: attachment.type,
          title: attachment.title,
          groups: attachment.groups,
          sfNode: attachment.sfNode,
          description: attachment.description,
          nodePath: attachment.nodePath,
          externalUrl: attachment.externalUrl,
          displayInUserHelp: attachment.displayInUserHelp,
          displayInUserHelpClassic: attachment.displayInUserHelpClassic,
          pushedAsSfHelpDate: attachment.pushedAsSfHelpDate
        };
      }
    });

    const action = <any>{
      createActivity: {
        mxKey: Number(data.mxKey),
        number: Number(data.number),
        text: data.text,
        position: {
          x: data.position.x,
          y: data.position.y,
          w: data.position.w,
          h: data.position.h
        },
        customStyle: data.customStyle,
        style: data.style,
        resources: data.resources,
        attachments: attachments,
        refModelAttachments: refModelAttachments,
        requirementAttachments: requirementAttachments,
        storyAttachments: storyAttachments,
        orgModelAttachments: orgModelAttachments,
        locked: Boolean(data.locked),
        linkedDiagram: data.linkedDiagram
      }
    };

    if (typeof data.container !== 'undefined') {
      action.createActivity.container = data.container;
    }

    if (typeof data.footerText !== 'undefined') {
      action.createActivity.footerText = data.footerText;
    }

    if (typeof data.attributes !== 'undefined') {
      action.createActivity.attributes = data.attributes;
    }

    if (data.imageUrl) {
      action.createActivity.imageUrl = data.imageUrl;
    }

    if (data.image) {
      action.createActivity.image = data.image;
    }

    if (typeof orderIndex !== 'undefined') {
      action.createActivity.orderIndex = orderIndex;
    }

    return this.services.diagramUpdateSvc.update(action);
  }
}
